// extracted by mini-css-extract-plugin
export default {"styleChooserSection":"F4-z","dimensionLabel":"G4-z","styleChooserControlWrapper":"H4-z","styleChooserControl":"I4-z","disabled":"J4-z","giftCard":"K4-z","styleChooserText":"L4-z"};